import { EditLogoStep } from './EditLogoStep';

type Props = {
  onClose: (confirmClose?: boolean) => void;
};

export const CreateLogoArtworkStepper: React.FC<Props> = ({ onClose }) => {
  return <EditLogoStep onClose={onClose} />;
};
